import React, { useEffect, useState } from "react";
import CarouselComponent from "./CarouselComponent";

const Hero = () => {
  const [heroData, setHeroData] = useState({
    title: "",
    bgColor: "",
    textColor: "",
    description: "",
    contactLink: "",
    contactText: "",
    ctaLink: "",
    ctaText: "",
  });

  const apiUrl = import.meta.env.VITE_API_URL;

  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        const response = await fetch(`${apiUrl}/home/hero`);
        const data = await response.json();
        setHeroData(data);
      } catch (error) {
        console.error("Error fetching hero data:", error);
      }
    };
    fetchHeroData();
  }, []);

  return (
    <div
      className="relative flex flex-col lg:flex-row items-center lg:items-stretch"
      style={{ backgroundColor: heroData.bgColor, color: heroData.textColor }}
    >
   
      {/* Carousel Section */}
      <div className="m-10 flex-1 w-3/4 lg:w-1/3 z-10 relative">
        <CarouselComponent />
      </div>

      {/* Text Section */}
      <div className="flex-1 flex flex-col justify-center p-8 lg:p-16 z-10 relative">
        <h1 className="text-2xl md:whitespace-nowrap lg:text-3xl font-bold mb-6 leading-tight text-alf">
          {heroData.title}
        </h1>
        <p className="text-md lg:text-xl font-light mb-8 text-justify">
          {heroData.description}
        </p>
        <div className="flex gap-4">
          <a
            href={heroData.contactLink}
            className="px-6 py-3 text-lg font-extrabold rounded-lg shadow-lg hover:scale-105 transition-transform bg-alf text-black"
          >
            {heroData.contactText}
          </a>
        
        </div>
      </div>
    </div>
  );
};

export default Hero;
